import React from "react";
import {Button, Paper, ClickAwayListener, TextField} from "@material-ui/core";
import "./RefundPopper.css"
import Autocomplete from "@material-ui/lab/Autocomplete";

class RefundPopper extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            refundType: this.props.refundType || '',
        };
    }

    handleChange = (e, value) => {
        this.setState({ refundType: value || ''});
    }

    handleClose = () => {
        this.props.handleClosePopper()
    }

    handleSave = () => {
        this.props.handleRefundTypeChange(this.state.refundType);
        this.props.handleClosePopper()
    }

    render() {
        return (
            <>
                <ClickAwayListener onClickAway={this.handleClose}>
                    <Paper className="refund-type-popper-container" style={{marginLeft:'8px'}}>

                        <div className="refund-type-popper-item">
                            <Autocomplete
                              options={this.props.options}
                              value={this.state.refundType}
                              onChange={this.handleChange} // Handles both setting state and calling the prop function
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  name="refundType"
                                  label="Select Refund Type"
                                  variant="outlined"
                                  InputLabelProps={{ shrink: true }}
                                />
                              )}
                              style={{ width: "400px" }}
                            />
                        </div>

                        <div className="refund-type-popper-buttons">
                            <Button variant='contained' onClick={this.handleClose} style={{width: '100px'}}>Cancel</Button>
                            <Button variant='contained'
                                    disabled={this.state.refundType === ''}
                                    onClick={this.handleSave} color="primary" style={{width: '100px'}}>Confirm</Button>
                        </div>
                    </Paper>
                </ClickAwayListener>
            </>
        )
    }
}


export default RefundPopper;